/**
 * Layout types:
 * FULL_PAGE - page is rendered on full width,
 * SPLIT - page is split to two sides.
 */
export const layoutTypes = {
    FULL_PAGE: 'full-page',
    SPLIT: 'split',
}

export const COLLAPSE_ANIMATION_TIME = 300
